import React, {lazy} from "react";
import { Row } from "antd";
import ScrollToTop from "../../common/ScrollToTop";
import { Fade } from "react-awesome-reveal";
import "./style.css";
import { PngIcon } from "../../common/PngIcon";

import SectionLine from "../../components/SectionLine";
import FAQ from "../../components/FAQ";
import Container from "../../common/Container";


const FaqPage = () => {
    return(
        <Container>
            <Fade>
                <ScrollToTop/>
                <Row id = 'intro'></Row>
                <div className="faqpage-wrapper">
                    <div id='top'/>
                    <div className="intro">
                        <div className="left">
                            <h1>FAQ</h1>
                            <h2>
                                Häufig gestellte Fragen <br/>rund um den Radentscheid.
                            </h2>
                        </div>
                        <div className="right">
                            <PngIcon
                                src="_radentscheid-logo-14-04-2023.jpg"
                                width="250px"
                                height="fit-content"/>
                        </div>
                    </div>
                    <SectionLine how="right"/>
                    <FAQ/>
                </div>
            </Fade>
        </Container>
    );
}

export default FaqPage;
